import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from 'store/reducers';

import { makeSelectHasClaim, selectClaimsLoaded } from '../store/slices/claimsSlice';

export type UseCanArgs = {
    type: string;
    action: string;
    resource?: string;
};

export const useCan = ({ type, action, resource }: UseCanArgs) => {
    const isLoaded = useSelector(selectClaimsLoaded);
    const selectHas = useMemo(() => makeSelectHasClaim({ type, action, resource }), [type, action, resource]);
    const can = useSelector((s: RootState) => selectHas(s));
    return { can, isLoaded };
};
